export default () => {
  return (
    <svg
      viewBox="0 0 51 30"
      width="36"
      height="36"
    >
      <path d="M46.6,29.2l1.3-.7-2.1-4h3.6L40,15.1V28.4l2.7-2.7L45,30.1l1.6-.9ZM39,12.69l1.71,1.71,6.51,6.51h1A2.83,2.83,0,0,0,51,18.07V2.83A2.83,2.83,0,0,0,48.17,0H2.83A2.83,2.83,0,0,0,0,2.83V18.07A2.83,2.83,0,0,0,2.83,20.9H39V12.69ZM8.33,9.22H42.67v2.45H8.33Z"></path>
    </svg>
  );
};
